import { useState } from 'react';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';

type Props = {
  initial: string;
  onSave: (notes: string) => void;
};

export const BagNotesField = ({ initial, onSave }: Props) => {
  const [value, setValue] = useState(initial);
  const [saved, setSaved] = useState(initial);

  const handleBlur = () => {
    if (value !== saved) {
      onSave(value);
      setSaved(value);
    }
  };

  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor="bag-notes">Notas internas</Label>
      <Textarea
        id="bag-notes"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onBlur={handleBlur}
        placeholder="Anotações internas sobre esta sacolinha..."
        rows={3}
      />
    </div>
  );
};
